module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/mlb/survive/wins-saves-1-47df22ad0e51d09f5b47a086e7369a80.svg";